<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col cols="12">
          <h2 class="text-center">{{$t('createKeywordsModal.title')}}</h2>
        </b-col>
        <span
          class="fa fa-sm fa-times corner-close hover"
          @click="close()"
        ></span>
      </b-row>
      <b-form novalidate @submit.stop.prevent="createKeywords">
        <b-row class="mt-3">
          <b-col cols="12">
            <b-form-group
              id="language-input-group"
              :label="$t('createKeywordsModal.languageLabel')"
              label-for="language-input"
            >
              <b-form-select
                id="language-input"
                name="language"
                v-model="selectedLanguage"
              >
                <option
                  v-for="language in supportLanguages"
                  :key="language"
                  :value="language">
                  {{language}}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              id="keywords-input-group"
              :label="$t('createKeywordsModal.keywordsLabel')"
              label-for="keywords-input"
            >
              <b-form-textarea
                class="keywords-text-area"
                id="keywords-input"
                name="keywords"
                v-model="keywords"
                rows="6"
                :placeholder="keywordsPlaceholder"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="6">
            <b-button
              variant="outline-primary"
              :disabled="submitting"
              @click="downloadCsv"
            >
              <span class="fa fa-download"></span>
              {{$t('createKeywordsModal.downloadCSV')}}
            </b-button>
          </b-col>
          <b-col cols="6">
            <input
              type="file"
              ref="file"
              style="display: none"
              accept="text/csv"
              @change="(event) => uploadCsv(event.target.files[0])"
            />
            <b-button
              variant="outline-success"
              :disabled="submitting || uploadingCSV"
              @click="$refs.file.click()"
            >
              <span class="fa fa-upload"></span>
              {{$t('createKeywordsModal.uploadCSV')}}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col cols="12">
            <loading-button
              :text="$t('createKeywordsModal.createKeywords')"
              :loading-text="$t('createKeywordsModal.createKeywordsLoading')"
              variant="primary"
              :loading="submitting"
              type="submit"
              :disabled="veeErrors.any() || uploadingCSV"
            />
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
  import Papa from 'papaparse';
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    computed: {
      keywordsPlaceholder() {
        return 'Keyword 1,\nKeyword 2,\nKeyword 3,\nKeyword 4,\nKeyword 5,';
      },
    },
    data() {
      return {
        uploadingCSV: false,
        submitting: false,
        selectedLanguage: 'en-GB',
        supportLanguages: ['en-GB'],
        keywords: '',
      };
    },
    methods: {
      createKeywords() {
        this.$validator.validateAll()
          .then((result) => {
            if (!result) {
              return;
            }
            this.submitting = true;
            this.$store.dispatch('keywords/createKeywords', {
              language: this.selectedLanguage,
              keywords: this.keywords,
            })
              .then(() => {
                // Close modal and show success
                this.$toasted.success(this.$t('createKeywordsModal.keywordsCreateSuccess'));
                this.submitting = false;
                this.close();
              })
              .catch(() => {
                this.submitting = false;
                this.$toasted.error(this.$t('createKeywordsModal.keywordsCreateError'));
              });
          });
      },
      uploadCsv(file) {
        if (!file) {
          return;
        }
        this.$toasted.info(this.$t('createKeywordsModal.uploadingCsv'));
        this.uploadingCSV = true;
        let keywords = '';
        let index = 0;
        Papa.parse(file, {
          worker: true,
          step: ({ data }) => {
            if (index !== 0) {
              const keyword = data[0];
              if (keyword !== null && keyword !== '' && keyword !== ' ') {
                keywords += `${keyword},\n`;
              }
            }
            index += 1;
          },
          complete: () => {
            this.keywords = keywords;
            this.uploadingCSV = false;
            this.$toasted.success(this.$t('createKeywordsModal.csvProcessed'));
          },
          error: () => {
            this.uploadingCSV = false;
            this.$toasted.error(this.$t('createKeywordsModal.csvError'));
          },
        });
      },
      downloadCsv() {
        const exampleCsv = 'keywords,\nKEYWORD_1,\nKEYWORD_2,\nKEYWORD_3,\nKEYWORD_4,\nKEYWORD_5,\n';
        const hiddenElement = document.createElement('a');
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(exampleCsv)}`;
        hiddenElement.target = '_blank';
        hiddenElement.download = 'scanMyAudioExampleCSV.csv';
        hiddenElement.click();
        hiddenElement.remove();
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>
  .keywords-text-area {
    max-height: 160px;
  }
</style>
